import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { ExternalIntegration } from "types/generated";
import { hasAdminAccess } from "utils/access";

const useCanManageExternalIntegration = (): ((integration: ExternalIntegration) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (integration: ExternalIntegration) => {
      if (integration.deleted) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      return hasAdminAccess(viewer, integration.spaceDetails.id);
    },
    [viewer]
  );
};

export default useCanManageExternalIntegration;
